var map = {
	"./ITALY-kit.png": 74786,
	"./australia-kit.webp": 20570,
	"./bangladesh-kit.webp": 3727,
	"./boland-kit.webp": 95640,
	"./boland-rocks-kit.webp": 35687,
	"./canada-kit.png": 9387,
	"./chennai-super-kings-kit.png": 7586,
	"./default-kit.webp": 63809,
	"./delhi-capitals-kit.png": 7789,
	"./dolphins-kit.webp": 26819,
	"./durban's-super-giants-kit.png": 60104,
	"./england-kit.webp": 59309,
	"./gujarat-titans-kit.png": 64373,
	"./india-kit.webp": 77399,
	"./ireland-kit.webp": 16115,
	"./joburg-super-kings-kit.png": 71871,
	"./knights-kit.webp": 26694,
	"./kolkata-knight-riders-kit.png": 25208,
	"./lions-kit.webp": 87271,
	"./lucknow-super-giants-kit.png": 37583,
	"./mi-cape-town-kit.png": 58262,
	"./mumbai-indians-kit.png": 37727,
	"./namibia-kit.png": 32672,
	"./new-zealand-kit.webp": 25762,
	"./north-west-dragons-kit.webp": 27074,
	"./oman-kit.png": 12728,
	"./paarl-royals-kit.png": 46416,
	"./pakistan-kit.webp": 50457,
	"./pretoria-capitals-kit.png": 45181,
	"./punjab-kings-kit.png": 23322,
	"./rajasthan-royals-kit.png": 30638,
	"./royal-challengers-bengaluru-kit.png": 64725,
	"./south-africa-kit.webp": 8968,
	"./sri-lanka-kit.webp": 88850,
	"./sunrisers-hyderabad-kit.png": 19160,
	"./sunrises-eastern-cape-kit.png": 57290,
	"./titans-kit.webp": 88633,
	"./tuskers-kit.webp": 27411,
	"./uae-kit.png": 1340,
	"./usa-kit.png": 4354,
	"./warriors-kit.webp": 51489,
	"./west-indies-kit.webp": 97934,
	"./western-province-kit.webp": 92351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66903;